"use client";
import * as React from "react";
import { useInView } from "@/hooks/use-in-view";
import { cn } from "@/lib/utils";

export function FadeUp({
  className,
  delay,
  children,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { delay?: number }) {
  const { ref, inView } = useInView<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={cn("fade-up-init", inView && "fade-up-in", className)}
      style={delay ? { transitionDelay: `${delay}s`, ...(style ?? {}) } : style}
      {...props}
    >
      {children}
    </div>
  );
}
